import { Link } from "react-router-dom";
import { Form, Formik } from "formik";
import { InputControl, SubmitButton } from "formik-chakra-ui";
import { useSignupUserMutation } from "../../store/api";
import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  HStack,
  InputRightElement,
  Stack,
  Button,
  Heading,
  Text,
  useColorModeValue,
  toast,
  useToast
} from '@chakra-ui/react';
import { useState } from 'react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

const Signup = () => {
  const [signupUser, { data, isLoading, isSuccess, isError, error }] = useSignupUserMutation();
  const [showPassword, setShowPassword] = useState(false);
  const toast = useToast();
  let formInitialState = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",

  };
  let [initialState, setInitialState] = useState(formInitialState);



  return (
    <Formik
      initialValues={{ ...initialState }}
      onSubmit={(values, { setSubmitting, resetForm, setErrors }) => {
        signupUser({ ...values, role: "user", isActive: false, watchProducts: [] }).then((res: any) => {
          if (res?.data?.success) {
            toast({
              title: data?.message || "Sign up successful! Please verify your email",
              status: "success",
              duration: 5000,
            });
            resetForm();
          } else if (res?.error) {
            toast({
              title: res?.error?.data?.message || "Sign up Failed",
              status: "error",
              duration: 5000,
            });
            setErrors(res?.error?.data);
          }
        }).catch(err => {
          toast({
            title: err?.data?.message || "Sign up failed",
            status: "error",
            duration: 5000,
          });
        });
      }}
    >
      <Form>
        <Flex
          minH={'100vh'}
          align={'center'}
          justify={'center'}
          bg={useColorModeValue('gray.50', 'gray.800')}>
          <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
            <Stack align={'center'}>
              <Heading fontSize={'4xl'} textAlign={'center'} color="teal">
                Sign up
              </Heading>
              {isSuccess &&
                <Text fontSize={'md'} textAlign={'center'} color="teal">
                  Registration success. Please check your email to activate your account.
                </Text>
              }
            </Stack>
            <Box
              rounded={'lg'}
              bg={useColorModeValue('white', 'gray.700')}
              boxShadow={'lg'}
              p={8}>
              <Stack spacing={4}>
                <HStack>
                  <Box>
                    <InputControl
                      isRequired
                      name="firstName"
                      label="First Name"
                      color="teal"
                      inputProps={{
                        placeholder: "Enter First name...",
                      }}
                    />
                  </Box>
                  <Box>
                    <InputControl
                      isRequired
                      name="lastName"
                      label="Last Name"
                      color="teal"
                      inputProps={{
                        placeholder: "Enter Last name...",
                      }}
                    />
                  </Box>
                </HStack>
                <InputControl
                  isRequired
                  name="email"
                  label="Email"
                  color="teal"
                  inputProps={{
                    type: "email",
                    placeholder: "Enter Email...",
                  }}
                />
                <FormControl id="password" isRequired>
                  <InputGroup>
                    <InputControl
                      name="password"
                      label="Password"
                      color="teal"
                      inputProps={{
                        placeholder: "Enter Password...",
                        type: showPassword ? 'text' : 'password'
                      }}
                    />
                    <InputRightElement h={'full'} pt={8}>
                      <Button
                        variant={'ghost'}
                        onClick={() =>
                          setShowPassword((showPassword) => !showPassword)
                        }>
                        {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                      </Button>
                    </InputRightElement>
                  </InputGroup>
                </FormControl>
                <Stack spacing={10} pt={2}>
                  <SubmitButton loadingText="Submitting"
                    size="lg"
                    bg={'teal'}
                    color={'white'}
                    _hover={{
                      bg: 'blue.500',
                    }}
                    isLoading={isLoading}>Sign Up</SubmitButton>
                </Stack>
                <Stack pt={6}>
                  <Text align={'center'}>
                    Already a user?
                    <Text pl={2} as={Link} to="/signin" color="teal">
                      Sign In
                    </Text>
                  </Text>
                </Stack>
              </Stack>
            </Box>
          </Stack>
        </Flex>
      </Form>
    </Formik >
  );
};

export default Signup;

